const products = [

    // Cocopeat / Coir Products
  {
    id: "CP001",
    image: require("../assets/products/cocopit/blocks.png"),
    name: "Cocopeat Blocks",
    category: "cocopeat_coir_products",
    description:
      "Coco Peat, also known as coir pith, is a non-fibrous, spongy, lightweight, and corky material that binds the coir fiber in coconut husk. Widely used in horticulture since the 1990s, coco peat has become one of the most preferred natural growing mediums due to its superior water retention, aeration, and nutrient-holding capacity. Its fluffy and loose structure ensures water remains available to plant roots for a longer duration, resulting in faster root growth and stronger plants. We offer Natural (Regular), Washed, and Buffered (Calcium Nitrate Treated) Cocopeat, compressed into convenient 5Kg blocks for easy handling and export.",
    hexCode: "25585DF56",
    hsCode: "53050040",
    benefits: [
      "Excellent water retention while maintaining proper aeration",
      "Encourages faster and healthier root development",
      "Retains nutrients and releases them to plant roots efficiently",
      "100% natural, biodegradable, and eco-friendly growing medium",
      "Available in Natural, Washed, and Buffered variants to suit diverse crops and soil conditions",
      "Suitable for horticulture, hydroponics, greenhouse farming, nurseries, and home gardening"
    ],
    specifications: {
      blockSize: "28 x 28 x 12 cm (approx.)",
      weight: "5 Kg (compressed in 1:5 ratio)",
      moisture: "10% – 15%",
      expansion: "70 – 80 liters per block",
      ph: "5.5 – 6.5",
      ec: "Low EC (< 0.5 mS/cm) / High EC (available)",
      loadability: "22 tonnes in a 40 ft container (22 pallets × 235 blocks)"
    },
    performance: "When 1 Kg of coco peat is hydrated with 3 liters of water, it expands to yield 15+ liters. A 5Kg block expands to approximately 75 liters of ready-to-use coco peat. Can be mixed with soil or used as a soilless growing medium for flowers, vegetables, fruits, and nursery applications.",
    specialMixers: [
      "60% Cocopeat + 40% Cut Fiber",
      "60% Cocopeat + 20% Cut Fiber + 20% Husk Chips",
      "90% Cocopeat + 10% Perlite",
      "95% Cocopeat + 5% Neem Cake"
    ],
    result: "A sustainable, high-performance growing medium that improves crop yield, plant strength, and soil health – making our Cocopeat Blocks (5Kg) the ideal choice for global agriculture"
  },
  {
    id: "CP002",
    image: require("../assets/products/cocopit/bric.png"),
    name: "Cocopeat Bricks",
    category: "cocopeat_coir_products",
    description:
      "Cocopeat Bricks are compressed, natural, and biodegradable products made from coco coir peat. They are compact, lightweight, easy to carry, and simple to use, making them ideal for nurseries, greenhouses, landscaping, hobby gardening, and even retail sales. When hydrated, a 650g cocopeat brick expands up to 10–12 liters, providing a versatile and eco-friendly growing medium.",
    hexCode: "25585DF56",
    hsCode: "53050040",
    applications: [
      "Nurseries – As potting soil base for seedlings and young plants",
      "Greenhouses – Used as a hydroponic growing medium",
      "Landscaping – Spread on lawns to promote greener pastures",
      "Retail & Hobby Gardening – Popular with home gardeners as an eco-friendly alternative to traditional peat",
      "Absorbent Use – Works as an effective oil, paint, and water spill absorber",
      "Composting – Used in worm bins and bio-compost preparation",
      "Animal Bedding – Suitable for small pet bedding due to its absorbent and soft nature"
    ],
    benefits: [
      "Compact size, easy to transport and store",
      "Highly absorbent – expands up to 15 times its volume",
      "100% natural, biodegradable, and eco-friendly",
      "Enhances water retention and aeration for plant roots",
      "Can be used alone or mixed with soil/fertilizer for better results"
    ],
    specifications: {
      weight: "650 g",
      size: "20 × 10 × 5 cm",
      volume: "9 L",
      itemsPerPallet: "2000 (± 5%)",
      palletsPerContainer: "20",
      totalWeight: "26MT"
    },
    howToUse: [
      "Place the unwrapped brick in a suitable container",
      "Add 4 liters of water uniformly on top",
      "Wait 30–45 minutes for the brick to expand",
      "Gently loosen the material with hand or tools",
      "The expanded brick (650g) produces 10–12 liters of planting medium",
      "Add more water as per plant requirements",
      "For spill absorption or animal bedding, dry the expanded material before use"
    ],
    result: "A versatile, eco-friendly, and easy-to-use growing medium for professional farming, landscaping, hobby gardening, and retail applications"
  },
  {
    id: "CP003",
    image: require("../assets/products/cocopit/GrowBags.png"),
    name: "Cocopeat Grow Bag",
    category: "cocopeat_coir_products",
    description:
      "Cocopeat Grow Bags are a sustainable and efficient alternative to traditional soil for horticulture, floriculture, and agriculture crops. They are especially useful in areas where the land is infertile, rocky, or unsuitable for cultivation, offering growers a ready-to-use medium that ensures healthy crop growth. Our UV-treated grow bags are manufactured to international standards and can last 1–3 years, depending on customer requirements.",
    hexCode: "25585DF56",
    hsCode: "53050040",
    types: [
      "Open Top Grow Bags",
      "Horizontal Multi-Hole Grow Bags"
    ],
    benefits: [
      "Fine dust (below 2mm) removed for maximum expansion",
      "Free from weeds, seeds, and microbial contamination",
      "Maintains an ideal air-to-water ratio when irrigated",
      "Long-term stability for extended usage",
      "100% natural, eco-friendly, and non-hazardous",
      "A sustainable substitute for hardwood and softwood bark"
    ],
    mixCombinations: [
      "Cocopeat + Husk Chips (1/4\", 1/2\", 3/4\", 1\")",
      "Cocopeat + Cut Fiber",
      "Cocopeat + Cut Fiber + Husk Chips",
      "Cocopeat + Perlite",
      "Cocopeat + Perlite + Vermiculite",
      "Cocopeat + Neem Cake"
    ],
    specifications: {
      compressedSize: "96 × 18 × 4 cm",
      expandedSize: "100 × 18 × 16 cm",
      volumeExpansion: "1 Kg pith = 14–20 Litres",
      ec: "< 1 (LEC – Low EC)",
      ph: "6 – 7",
      compressionRatio: "5:1",
      unitWeight: "~3 Kg",
      packing: "UV Treated Poly Bag (1–3 years durability)",
      loadability: "~7,400 grow bags per 40' HC FCL"
    },
    suitableFor: "Tomato, chilli, cucumber, capsicum, strawberry, ginger, carnations, lilium, herbs, and more",
    result: "Our Cocopeat Grow Bags provide an ideal balance of water retention, aeration, and nutrient support, ensuring higher yields, healthier roots, and sustainable farming practices for both commercial growers and hobby gardeners"
  },
  {
    id: "CP004",
    image: require("../assets/products/cocopit/HuskChipBlock.png"),
    name: "Huskchips Block",
    category: "cocopeat_coir_products",
    description:
      "Coco Husk Chips are an organic material derived from the fibrous hulls of coconuts. Naturally highly porous, they are widely used in hydroponic systems as well as soil-based gardening to improve drainage, aeration, and root health. The chips are produced by cutting dried coconut husks into small cubic-shaped pieces, available in multiple sizes. They are often mixed with coco peat to regulate the air-to-moisture balance, creating an ideal growing medium for flowers, vegetables, fruits, and ornamentals.",
    hexCode: "25585DF56",
    hsCode: "53050040",
    benefits: [
      "Improved Drainage & Aeration – Prevents waterlogging and enhances oxygen flow to plant roots",
      "Ideal Growing Medium – Can be used alone, or mixed with coco peat, potting soil, or other media",
      "Moisture Regulation – Balances water retention and air circulation for healthier root growth",
      "Versatile Applications – Suitable for hydroponics, greenhouse farming, nursery beds, potted plants, and landscaping",
      "Eco-Friendly & Sustainable – 100% natural, renewable, and biodegradable material"
    ],
    specifications: {
      blockWeight: "5 Kg",
      blockSize: "30 × 30 × 12 cm",
      chipSize: "6–18 mm / 10–20 mm (customizable)",
      color: "Natural brown",
      moisture: "Below 15%",
      volumeYield: "10–15 liters per Kg",
      loadability: "22 tonnes in a 40 ft container (22 pallets)",
      processing: "Dried, Washed & Dried, or Buffered & Dried"
    },
    specialMixers: [
      "60% Cocopeat + 40% Cut Fiber",
      "60% Cocopeat + 20% Cut Fiber + 20% Husk Chips",
      "90% Cocopeat + 10% Perlite",
      "95% Cocopeat + 5% Neem Cake"
    ],
    result: "Enhanced soil structure, stronger root systems, healthier crops, and higher yields with our premium Coco Husk Chips Blocks and custom cocopeat blends"
  },
  
  // Organic Fertilizers
  {
    id: "OF001",
    image: require("../assets/products/organic/mushroom.png"),
    name: "SoilGold Organic Manure",
    category: "organic_fertilizers",
    description:
      "Our SoilGold Organic Manure is prepared from organic waste generated by mushroom industries. The waste is carefully processed with beneficial microorganisms and enriched with essential bacterial cultures, making it a rich source of all major macro and micronutrients. This premium compost not only supplies vital nutrients but also acts as an excellent soil conditioner, improving the physical, chemical, and biological properties of the soil.",
    hexCode: "25585DF53",
    hsCode: "31010090",
    benefits: [
      "Rich in Organic Carbon – A completely decomposed fertilizer that enhances soil fertility",
      "Soil Health Improvement – Enhances physical, chemical, and biological properties of the soil",
      "Natural Plant Protection – Helps protect crops from soil-borne diseases",
      "Enhanced Water Retention – Improves the soil's water-holding capacity, supporting plant growth during dry conditions",
      "Sustainable Soil Quality – Long-lasting organic matter enrichment"
    ]
  },
  {
    id: "OF002",
    image: require("../assets/products/organic/vermicompost.png"),
    name: "Vermicompost – 100% Cow Dung Based",
    category: "organic_fertilizers",
    description:
      "Our Vermicompost is produced exclusively from 100% pure cow dung, processed naturally with the help of earthworms. This ensures a nutrient-rich, chemical-free, and eco-friendly organic fertilizer that not only nourishes crops but also revitalizes soil health. Unlike synthetic fertilizers, cow dung-based vermicompost provides a slow-release supply of nutrients, improves soil structure, and enhances microbial activity, ensuring long-lasting fertility.",
    hexCode: "25585DF53",
    hsCode: "31010099",
    benefits: [
      "100% Natural & Pure – Made only from cow dung, free from waste materials or additives",
      "Balanced Nutrient Source – Rich in NPK (Nitrogen, Phosphorus, Potassium) along with essential micronutrients",
      "Boosts Microbial Activity – Enhances beneficial soil microorganisms for better soil biology",
      "Improves Soil Structure – Increases porosity, aeration, and water-holding capacity",
      "Enhances Crop Growth & Quality – Promotes robust root development, greener foliage, tastier fruits, and better yields",
      "Soil Health Restoration – Improves organic carbon levels and regulates soil pH",
      "Eco-Friendly & Sustainable – 100% biodegradable and supports organic farming practices",
      "Long-Term Productivity – Increases soil fertility with regular application"
    ],
    suitableFor: "Cereals, pulses, vegetables, fruits, flowers, plantation crops, nurseries, and organic farms"
  },
  {
    id: "OF003",
    image: require("../assets/products/organic/neemfuitpowder.png"),
    name: "Neem Fruit Powder",
    category: "organic_fertilizers",
    description:
      "In organic farming, various oil seed cakes are used as natural sources of nutrients. Neem Fruit Powder is an excellent organic fertilizer that combines NPK along with essential micronutrients and also offers natural pesticidal properties. With a high nitrogen content of 4.5% and azadirachtin content of 700 ppm, it is highly valued by organic farmers. It is particularly effective against soil-borne pests and nematodes while enriching soil health.",
    hexCode: "25585DF53",
    hsCode: "12119029",
    benefits: [
      "Natural Pest & Insect Control – Contains neem oil and azadirachtin that effectively manage soil insects like termites, white grubs, and mealybugs",
      "Dual Application – Can be soaked overnight in water to prepare an insecticidal spray extract",
      "Fungal Disease Management – Helps in controlling various fungal infections in crops",
      "Soil Health Enhancer – Improves soil porosity, increases organic carbon, and enhances physical, chemical, and biological properties",
      "Supports Beneficial Microorganisms – Protein content acts as a booster for microbial activity",
      "Nutrient Rich – Provides primary, secondary, and micronutrients; acts as a slow-release nutrient source",
      "Synergistic with Fertilizers – Can be combined with nitrogenous fertilizers to prevent nitrogen loss",
      "Nematode Management – Azadirachtin acts as a natural systemic insecticide and fungicide"
    ],
    result: "Increased crop growth, higher yields, improved soil fertility, and sustainable pest management"
  },
  {
    id: "OF004",
    image: require("../assets/products/organic/castordoc.png"),
    name: "Castor Cake",
    category: "organic_fertilizers",
    description:
      "Castor Cake is produced by crushing castor seeds in an expeller under controlled temperature with the help of steam to extract oil. What remains is a nutrient-rich organic manure that enhances soil fertility without causing any harm or decay. It provides long-term natural immunity to crops and soil, making it one of the most versatile natural manures. Castor Cake is enriched with the three major elements vital for crop growth – Nitrogen, Phosphorus, and Potassium (NPK) – along with trace minerals like Manganese, Zinc, and Copper, making it a perfectly balanced organic fertilizer. This slow-release organic manure nourishes crops steadily, stimulates growth, protects against soil nematodes and insects, and improves both the yield and quality of farm produce, including taste, flavor, and amino acid composition.",
    hexCode: "25585DF53",
    hsCode: "23069017",
    benefits: [
      "Complete Nutrient Source – Supplies major (NPK) and minor nutrients for optimal plant growth",
      "Enhanced Nutrient Uptake – Improves plants' ability to absorb nutrients effectively",
      "Soil Aeration – Enhances soil structure for better root development",
      "Supports Soil Life – Improves fertility, increases humus, and encourages earthworm growth",
      "Soil Health & Balance – Regulates soil pH and enhances physical, chemical, and biological properties",
      "Natural Pest Protection – Provides protection against nematodes, termites, and other soil-borne pests",
      "Moisture Retention – Increases soil's organic carbon and water-holding capacity",
      "Improves Crop Quality – Enhances shininess of fruits, improves taste, flavor, and overall quality of produce",
      "Boosts Soil & Crop Immunity – Strengthens natural defense mechanisms of crops and soil for long-term sustainability"
    ],
    result: "Better soil fertility, healthier crops, improved yield and quality, and sustainable farming with Castor Cake Organic Manure"
  },

  // Herbal Products
  {
    id: "HP001",
    image: require("../assets/products/herbal_products/artqualityheenapowder.png"),
    name: "Body Art Quality Heena Powder",
    category: "herbal_products",
    description:
      "Finely sifted, pure henna powder ideal for body art applications, offering deep color and natural staining properties.",
    hexCode: "25585DF54",
    hsCode: "14041019",
  },
  {
    id: "HP002",
    image: require("../assets/products/herbal_products/herbalhennapowder.png"),
    name: "Herbal Heena Powder",
    category: "herbal_products",
    description:
      "Our Herbal Henna Powder (Lawsonia Inermis) is a unique blend of premium quality henna leaves enriched with the goodness of 9 powerful herbs: Amla, Shikakai, Reetha, Bhringraj, Hibiscus, Jatamasi, Katha, Neem, and Kapoor Kachli. This herbal combination not only provides natural colour but also deeply nourishes and strengthens hair, making it an ideal alternative to chemical-based hair products.",
    hexCode: "25585DF54",
    hsCode: "14041019",
    benefits: [
      "Natural Coloring – Provides rich, long-lasting natural hair color",
      "Strengthens Hair – Amla, Bhringraj, and Hibiscus promote stronger, thicker hair",
      "Deep Conditioning – Shikakai, Reetha, and Neem cleanse and condition naturally",
      "Promotes Scalp Health – Herbal mix helps reduce dandruff, dryness, and scalp irritation",
      "100% Natural & Safe – No chemicals, no additives, no preservatives"
    ]
  },
  {
    id: "HP003",
    image: require("../assets/products/herbal_products/NaturalHennaPowder.png"),
    name: "Natural Heena Powder",
    category: "herbal_products",
    description:
      "Our Organic Natural Henna Powder (Lawsonia Inermis) is a safe and natural alternative to synthetic hair dyes, making it an ideal choice for people with sensitive scalps or allergies to chemical-based products. Prepared using finest quality henna leaves from Sojat, Rajasthan (India), this powder is carefully processed to maintain purity, freshness, and natural colour properties. We follow strict quality standards to ensure every batch is 100% natural, chemical-free, and eco-friendly.",
    hexCode: "25585DF54",
    hsCode: "14041019",
    benefits: [
      "100% Natural & Herbal – Made from pure henna leaves with no additives, preservatives, or synthetic colours",
      "Chemical-Free – Free from sulphates, parabens, GMOs, synthetic fragrances, and harmful chemicals",
      "Steam-Sterilized Herbs – Ensures hygienic, safe, and premium-quality product",
      "Gentle & Safe – Suitable for all skin and hair types, even sensitive scalps",
      "Natural Colour & Shine – Provides rich, long-lasting colour while strengthening and conditioning hair",
      "Eco-Friendly – 100% biodegradable and sustainably sourced"
    ],
    applications: [
      "Hair Care – Natural hair colouring, strengthening, and conditioning",
      "Body Art (Mehndi) – Traditional henna designs for weddings, festivals, and cultural celebrations",
      "Herbal & Cosmetic Industry – Used in herbal hair care products, shampoos, and herbal treatments"
    ],
    specifications: {
      type: "Herbal Extract (Henna Powder)",
      form: "Powder",
      partUsed: "Henna Leaves",
      cultivation: "Wild",
      inciName: "Lawsonia Inermis",
      lawsoneContent: "1.50% – 2.80%",
      colorShades: "Light Green, Dark Green, Wooden Green",
      grade: "A",
      productionCapacity: "5–10 Tons Per Day",
      certificates: "ISO 9001:2015, GMP, HACCP, FSSAI, MSME",
      origin: "Sojat, Rajasthan, India"
    },
    result: "A premium-quality, natural henna powder trusted by herbal, cosmetic, and personal care industries worldwide"
  },
  {
    id: "HP004",
    image: require("../assets/products/herbal_products/Multani_Mitti.png"),
    name: "Superfine Multani Mitti",
    category: "herbal_products",
    description:
      "Superfine Multani Mitti Powder, also known as Fuller's Earth, is a 100% pure, triple-sifted, microfine clay powder enriched with essential natural minerals such as magnesium, calcium, silica, calcite, iron, and dolomite. Widely used in skincare, haircare, cosmetics, and herbal formulations, Multani Mitti is known for its detoxifying, cleansing, and purifying properties.",
    hexCode: "25585DF54",
    hsCode: "33049990",
    benefits: [
      "For Skin: Deeply cleanses and detoxifies",
      "Unclogs pores and absorbs excess oil",
      "Helps dry up acne and pimples",
      "Reduces scars and blemishes",
      "Adds natural glow and freshness to skin",
      "For Hair: Naturally cleanses scalp",
      "Acts as a gentle conditioner",
      "Removes impurities and excess oil",
      "Promotes stronger and healthier hair"
    ],
    specifications: {
      type: "Natural Multani Mitti (Fuller's Earth)",
      form: "Triple-sifted, microfine powder",
      purity: "100% Pure"
    }
  },

  // Bagasse Tableware
  {
    id: "BT001",
    image: require("../assets/products/bagasse/bowls.png"),
    images: [
      require("../assets/products/bagasse/bowls.png"),
      require("../assets/products/bagasse/bowl.png"),
     
    ],
    name: "Bowl",
    category: "bagasse_tableware",
    description:
      "At Nirmita International, we pioneer sustainable dining solutions with eco-friendly tableware made from bagasse and PLA. Designed for durability and 100% compostability, our products are the perfect alternative to plastic, Styrofoam, and other non-biodegradable options. These eco-friendly disposable bowls made from sugarcane bagasse are suitable for serving hot or cold foods sustainably.",
    hexCode: "25585DF55",
    hsCode: "48237010",
    features: [
      "FDA-approved for added reassurance",
      "Available in all standard sizes",
      "Custom-moulded biodegradable products on request",
      "Export-quality compostable packaging solutions",
      "PFAS-free, Made in India"
    ],
    certifications: "ISO 9001, ISO 22000, ISO 14001, ISO 45001, BRCGS Packaging, TÜV Austria (OK Compost Home & Industrial), BPI Compostability, and SEDE",
    suitableFor: "Importers, restaurants, catering services, wholesalers, and retail chains worldwide"
  },
  {
    id: "BT002",
    image: require("../assets/products/bagasse/clamshells.png"),
    images: [
      require("../assets/products/bagasse/clamshells.png"),
      require("../assets/products/bagasse/ClamShell.png")
     
    ],
    name: "Clam Shell",
    category: "bagasse_tableware",
    description:
      "At Nirmita International, we pioneer sustainable dining solutions with eco-friendly tableware made from bagasse and PLA. Designed for durability and 100% compostability, our products are the perfect alternative to plastic, Styrofoam, and other non-biodegradable options. These sturdy and compostable clamshell containers made from bagasse are ideal for takeaway meals and food packaging.",
    hexCode: "25585DF55",
    hsCode: "48237010",
    features: [
      "FDA-approved for added reassurance",
      "Available in all standard sizes",
      "Custom-moulded biodegradable products on request",
      "Export-quality compostable packaging solutions",
      "PFAS-free, Made in India"
    ],
    certifications: "ISO 9001, ISO 22000, ISO 14001, ISO 45001, BRCGS Packaging, TÜV Austria (OK Compost Home & Industrial), BPI Compostability, and SEDE",
    suitableFor: "Importers, restaurants, catering services, wholesalers, and retail chains worldwide"
  },
  {
    id: "BT003",
    image: require("../assets/products/bagasse/MealTray.png"),
    images: [
      require("../assets/products/bagasse/MealTray.png"),
      require("../assets/products/bagasse/MealTray1.png")
    
    ],
    name: "Meal Tray",
    category: "bagasse_tableware",
    description:
      "At Nirmita International, we pioneer sustainable dining solutions with eco-friendly tableware made from bagasse and PLA. Designed for durability and 100% compostability, our products are the perfect alternative to plastic, Styrofoam, and other non-biodegradable options. These biodegradable meal trays with multiple compartments made from sugarcane pulp are perfect for catering and food services.",
    hexCode: "25585DF55",
    hsCode: "48237010",
    features: [
      "FDA-approved for added reassurance",
      "Available in all standard sizes",
      "Custom-moulded biodegradable products on request",
      "Export-quality compostable packaging solutions",
      "PFAS-free, Made in India"
    ],
    certifications: "ISO 9001, ISO 22000, ISO 14001, ISO 45001, BRCGS Packaging, TÜV Austria (OK Compost Home & Industrial), BPI Compostability, and SEDE",
    suitableFor: "Importers, restaurants, catering services, wholesalers, and retail chains worldwide"
  },
  {
    id: "BT004",
    image: require("../assets/products/bagasse/Plates.png"),
    images: [
      require("../assets/products/bagasse/Plates.png"),
      require("../assets/products/bagasse/Plate.png")
    
    ],
    name: "Plates",
    category: "bagasse_tableware",
    description:
      "At Nirmita International, we pioneer sustainable dining solutions with eco-friendly tableware made from bagasse and PLA. Designed for durability and 100% compostability, our products are the perfect alternative to plastic, Styrofoam, and other non-biodegradable options. These durable and compostable plates made from bagasse offer a sustainable alternative to plastic and foam plates.",
    hexCode: "25585DF55",
    hsCode: "48237010",
    features: [
      "FDA-approved for added reassurance",
      "Available in all standard sizes",
      "Custom-moulded biodegradable products on request",
      "Export-quality compostable packaging solutions",
      "PFAS-free, Made in India"
    ],
    certifications: "ISO 9001, ISO 22000, ISO 14001, ISO 45001, BRCGS Packaging, TÜV Austria (OK Compost Home & Industrial), BPI Compostability, and SEDE",
    suitableFor: "Importers, restaurants, catering services, wholesalers, and retail chains worldwide"
  },


];

export default products;